import styled, { keyframes } from "styled-components";
import { theme } from "styles/theme";

const shimmer = keyframes`
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
`;

const Card = styled.div`
  background-color: ${theme.colors.surface};
  border: 1px solid ${theme.colors.borderLight};
  border-radius: ${theme.borderRadius.medium};
  padding: 1.5rem;
  box-shadow: ${theme.shadows.small};
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

const Bone = styled.div<{ $width?: string; $height?: string }>`
  width: ${({ $width }) => $width ?? "100%"};
  height: ${({ $height }) => $height ?? "0.875rem"};
  border-radius: ${theme.borderRadius.small};
  background: linear-gradient(
    90deg,
    ${theme.colors.lightGrey} 0%,
    ${theme.colors.bgLight} 50%,
    ${theme.colors.lightGrey} 100%
  );
  background-size: 200% 100%;
  animation: ${shimmer} 1.4s ease-in-out infinite;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
    background: ${theme.colors.lightGrey};
  }
`;

interface SkeletonCardProps {
  lines?: number;
}

export function SkeletonCard({ lines = 4 }: SkeletonCardProps) {
  return (
    <Card aria-hidden role="presentation">
      <Bone $width="55%" $height="1.25rem" />
      {Array.from({ length: lines }, (_, index) => (
        <Bone
          key={index}
          $width={index % 2 === 0 ? "100%" : "72%"}
        />
      ))}
      <Bone $width="40%" $height="2.25rem" />
    </Card>
  );
}
